import { Component, OnInit } from '@angular/core';

import { FirebaseConfig } from '@models/common/settings.model';
import { environment } from '@environments/environment';
import { set } from 'lodash';

@Component({
  selector: 'app-firebase-config',
  standalone: true,
  imports: [],
  template: ` <div id="firebase-config-container" style="display: none;"></div> `,
  styles: ``,
})
export class FirebaseConfigComponent implements OnInit {
  firebaseConfig: FirebaseConfig = environment.firebaseConfig;

  ngOnInit(): void {
    // Expose config globally for service worker access
    set(window, 'firebaseConfig', this.firebaseConfig);

    // Create script tag for service worker access
    this.createScriptTag();
  }

  private createScriptTag(): void {
    // Remove existing script tag if any
    const existingScript = document.getElementById('firebase-config-data');
    if (existingScript) {
      existingScript.remove();
    }

    // Create new script tag
    const script = document.createElement('script');
    script.id = 'firebase-config-data';
    script.type = 'application/json';
    script.textContent = JSON.stringify(this.firebaseConfig);
    script.style.display = 'none';
    
    // Append to document head
    document.head.appendChild(script);
  }
}
